import { useAuth0 } from '@auth0/auth0-react';
import { axios, orvalAxios } from '@ben/api/axios';
import Loader from '@ben/orion/loader';
import * as Sentry from '@sentry/react';
import type { InternalAxiosRequestConfig } from 'axios';
import { useEffect } from 'react';
import { FallbackComponent } from '../components/error-fallback/fallback-component';
import AppRoutes from '../routes';
import LoginScreen from '../screens/login/login';
import './app.scss';

const App = () => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const fallback = <FallbackComponent />;

  // Axios interceptor to add auth header to all requests
  useEffect(() => {
    const authInterceptor = async (request: InternalAxiosRequestConfig) => {
      const accessToken = await getAccessTokenSilently();
      if (accessToken && request.headers) {
        request.headers['Authorization'] = `Bearer ${accessToken}`;
      }
      return request;
    };

    const requestInterceptor = axios.interceptors.request.use(authInterceptor);
    const orvalRequestInterceptor =
      orvalAxios.interceptors.request.use(authInterceptor);

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      orvalAxios.interceptors.request.eject(orvalRequestInterceptor);
    };
  }, [getAccessTokenSilently]);

  if (isAuthenticated) {
    return (
      <Sentry.ErrorBoundary fallback={fallback}>
        <AppRoutes />
      </Sentry.ErrorBoundary>
    );
  }

  return isLoading ? <Loader variant="full-screen" /> : <LoginScreen />;
};

export default App;
